var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{path:'/'}}},[(!_vm.collapsed)?_c('span',{staticClass:"logo-icon"}):_c('span',{staticClass:"logo-small-icon"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }